<template>
  <div class="depositAgreement">
    <div class="title titleColor1">ARCFOX车辆购买定金协议V3.0</div>
    <div>
      <p class="text-bold" style="text-indent: 0; margin-bottom: 0.2rem;">
        感谢您选择认购极狐汽车产品!为保障您的购车权益，请您在支付定金前仔细阅读本协议全部内容，特别是黑体字所凸显的内容，本协议经您确认后即刻生效。
      </p>
    </div>
    <div>
      <p>
        本 《ARCFOX车辆购买定金协议》 （“本协议”） 适用北京蓝谷极狐汽车科技有限公司 （“极狐汽车”） 与希望购买极狐汽车ARCFOX品牌汽车的用户（“用户”）之间，购买ARCFOX品牌电动汽车的相关事宜。
      </p>
    </div>
    <div class="sub titleColor1">一、 购买</div>
    <div>
      <p>
        本协议的目的为确认用户同意依据本协议中的条款向极狐汽车购买在车辆配置方案中选定的汽车。<span class="text-bold">用户同意极狐汽车可以自行决定委托极狐汽车的授权经销商履行本协议下的全部或部分义务。</span>在车辆满足交付条件后可由极狐汽车或极狐汽车委托的<span class="text-bold">授权经销商</span>与用户完成后续的车辆购买事宜，包括签署正式购车协议、交付车辆、开具发票，直至完成交易。
      </p>
    </div>
    <div class="sub titleColor1">二、 定金支付</div>
    <div>
      <p>
        为购买ARCFOX品牌电动汽车，用户同意根据极狐汽车提供的支付方式（包括但不限于微信、支付宝等）向极狐汽车支付购车定金5000元。
      </p>
      <p>
        用户确认并同意，如其最终与极狐汽车授权经销商签署车辆购买协议的，则本协议项下定金转为前述车辆购买协议项下购车款。用户同意并委托极狐汽车在审核相应资料或信息后将前述定金支付给与用户交易的授权经销商。届时，本协议自动终止，极狐汽车无须向用户退还任何款项。
      </p>
      <p>
        对于符合赠送家用充电桩权益的用户，可根据自身需求在支付定金后申请安装充电桩（不含港澳台及海外）。若家用充电桩已经安装完成，但因用户原因拒绝签署、单方解除或终止车辆购买协议，或因用户的原因致使车辆购买协议解除或无法履行的，极狐汽车将不予退还定金。
      </p>
    </div>
    <div class="sub titleColor1">三、 犹豫期</div>
    <div class="text-bold">
      <p>自用户支付定金时起72小时属于犹豫期。</p>
      <p>
        犹豫期内，用户可在ARCFOX极狐APP订单详情中修改车辆配置或申请退还定金。极狐汽车将向用户原路无息退还已支付的全部定金。
      </p>
      <p>
        特别提示，支付定金满72小时，犹豫期结束，将会自动锁定订单（以下简称“锁单”）。
      </p>
      <p>
        用户可以在犹豫期期内主动在ARCFOX极狐APP提前锁单，视为用户提前结束犹豫期。
      </p>
      <p>
        锁单后，极狐汽车将安排生产车辆，配置不可再修改，定金不可退。
      </p>
      <p>
        极狐汽车用户定金申请退还后，本协议将自动终止。
      </p>
      <p>
        用户对此知悉并理解，犹豫期届满，极狐汽车将不再受理用户提出的退还已付定金的申请，前述定金将不能退还。
      </p>
    </div>
    <div class="sub titleColor1">四、 争议解决</div>
    <div>
      <p>
        用户确认并同意，因本协议引起的或与本协议有关的任何争议，应通过友好协商的方式解决，双方不愿协商或协商不成的，任何一方有权向本协议有管辖权的人民法院提起诉讼。
      </p>
    </div>
    <div class="sub titleColor1">五、 其他</div>
    <div>
      <p>
        本协议均于用户确认订单且支付定金之日生效。
      </p>
      <p>
        本协议的签订地为北京市大兴区。
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nowOrderSaleModel: "",
    };
  },
  created() {
    this.getUrlParams();
    if (this.nowOrderSaleModel == "EXPECT") {
      this.$router.replace({ path: "/advanceRule?colorMode=darkMode&source=app" });
    }
  },
  methods: {
    getUrlParams() {
      let query = window.location.search.substring(1);
      let vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == "nowOrderSaleModel") {
          this.nowOrderSaleModel = pair[1];
        }
      }
      return;
    },
  },
};
</script>

<style lang="scss">
.depositAgreement {
  padding: 0.1rem 0.2rem;
  p {
    text-indent: 0.34rem;
    word-wrap: break-word;
    text-align: justify;
  }
  .title {
    text-align: center;
    font-weight: bold;
  }
  .sub {
    font-weight: bold;
  }
}
.titleColor1 {
  margin: 0.2rem 0;
  font-size: 0.16rem;
  line-height: 0.22rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}

.darkMode .titleColor1 {
  color: #f5f5f5 !important;
}
.darkMode p {
  color: #c8c8c8 !important;
}
p,
span {
  font-size: 0.16rem !important;
  line-height: 0.27rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.date {
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 0.26rem;
  text-align: center;
}
.darkMode .date {
  color: #7e7e7f !important;
}
.date {
  font-size: 0.14rem !important;
}
.depositAgreement {
  .text-bold {
    font-weight: bold;
    p {
      font-weight: bold;
    }
  }
}
</style>
